/*
 * custom-filters.js — Reciclibros
 * ------------------------------------------------------------
 * Filtrage custom pour les GROSSES collections (> 5000 produits) et la page /search,
 * la ou le moteur de facettes natif Shopify ne calcule/n'applique plus rien.
 *
 * Principe : on REUTILISE au maximum les coquilles natives du theme Bookifa
 * (drawer <ap-facetfilters>, collapsibles <ap-contentcollapsible>+toggle-button,
 * slider .ap-pricerange) et on ne remplace que la SOURCE DE DONNEES (Storefront API).
 * Les cartes clonent le markup de product-grid.liquid (zero divergence visuelle).
 *
 * Ne s'active QUE si window.CF_CONFIG est present. <=5000 => natif intact.
 * ------------------------------------------------------------
 */
(function () {
  'use strict';

  var cfg = window.CF_CONFIG;
  if (!cfg || !cfg.token) return;

  // Endpoint SAME-ORIGIN (domaine courant) : evite toute requete "tierce" cross-domaine
  // que certains bloqueurs de contenu / navigateurs coupent. Le fallback reste le domaine
  // configure si jamais l'origine courante n'est pas un domaine de la boutique.
  var SHOP_DOMAINS = ['myshopify.com', 'reciclibros.com'];
  var isShopOrigin = SHOP_DOMAINS.some(function (d) { return location.hostname.indexOf(d) !== -1; });
  var API_URL = (isShopOrigin ? location.origin : 'https://' + cfg.shop) + '/api/' + cfg.apiVersion + '/graphql.json';
  var PER_PAGE = cfg.perPage || 48;

  // ---------------------------------------------------------------------------
  // Client GraphQL Storefront
  // ---------------------------------------------------------------------------
  function gql(query, variables) {
    return fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': cfg.token },
      body: JSON.stringify({ query: query, variables: variables || {} })
    }).then(function (r) { return r.json(); }).then(function (json) {
      if (json.errors && json.errors.length) console.warn('[custom-filters] GraphQL errors', json.errors);
      return json.data;
    });
  }

  // ---------------------------------------------------------------------------
  // Formatage monetaire (reproduit {{ ... | money }})
  // ---------------------------------------------------------------------------
  function withCommaSeparator(a) { var n = parseFloat(a || 0), p = n.toFixed(2).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'); return p[0] + ',' + p[1]; }
  function withDotSeparator(a) { var n = parseFloat(a || 0), p = n.toFixed(2).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); return p[0] + '.' + p[1]; }
  function noDecimals(a) { var n = Math.round(parseFloat(a || 0)); return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function money(a) {
    return (cfg.moneyFormat || '{{amount}} €')
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals(a))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals(a))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withCommaSeparator(a))
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, withCommaSeparator(a))
      .replace(/\{\{\s*amount\s*\}\}/g, withDotSeparator(a));
  }

  // ---------------------------------------------------------------------------
  // Utilitaires
  // ---------------------------------------------------------------------------
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;'); }
  function gidNum(g) { return g ? String(g).split('/').pop() : ''; }
  function truncateWords(str, n) { var w = String(str || '').trim().split(/\s+/); return w.length <= n ? str : w.slice(0, n).join(' ') + '...'; }
  function imgUrl(base, w) { return base ? base + (base.indexOf('?') === -1 ? '?' : '&') + 'width=' + w : ''; }
  function clamp(v, lo, hi) { return Math.min(Math.max(v, lo), hi); }

  // Icones inlinees depuis les snippets Bookifa
  var ICON_WISHLIST = '<div class="icon-product"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path d="M9.99381 2.87856C7.99273 1.20992 5.08354 0.891102 2.8126 2.83145C0.32332 4.95834 -0.0402306 8.54472 1.93052 11.0807C2.66674 12.028 4.09533 13.4422 5.45783 14.7282C6.83947 16.0323 8.21758 17.2643 8.89705 17.866C8.90151 17.87 8.9061 17.8741 8.91081 17.8782C8.97358 17.9339 9.0579 18.0086 9.13969 18.0702C9.23936 18.1453 9.38828 18.243 9.58926 18.3029C9.85277 18.3815 10.1357 18.3815 10.3992 18.3029C10.6002 18.243 10.7491 18.1453 10.8488 18.0702C10.9306 18.0086 11.0149 17.9339 11.0777 17.8782C11.0824 17.874 11.087 17.87 11.0914 17.866C11.7709 17.2643 13.149 16.0323 14.5307 14.7282C15.8932 13.4422 17.3218 12.028 18.058 11.0807C20.0199 8.55608 19.7144 4.9412 17.1655 2.82268C14.8714 0.915949 11.9924 1.20942 9.99381 2.87856Z" fill="currentColor"/></svg></div>';
  var ICON_QUICKVIEW = '<div class="icon-product"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.40569 6.997C4.16878 8.02934 3.30115 9.2447 2.86227 9.93962C2.84737 9.9632 2.83498 9.98285 2.82426 9.99996C2.83498 10.0171 2.84737 10.0367 2.86227 10.0603C3.30115 10.7552 4.16878 11.9706 5.40569 13.0029C6.64025 14.0333 8.18242 14.8333 10.0003 14.8333C11.8183 14.8333 13.3604 14.0333 14.595 13.0029C15.8319 11.9706 16.6995 10.7552 17.1384 10.0603C17.1533 10.0367 17.1657 10.0171 17.1764 9.99996C17.1657 9.98285 17.1533 9.9632 17.1384 9.93962C16.6995 9.2447 15.8319 8.02934 14.595 6.997C13.3604 5.96662 11.8183 5.16663 10.0003 5.16663C8.18242 5.16663 6.64025 5.96662 5.40569 6.997ZM4.12416 5.46153C5.58338 4.24364 7.56408 3.16663 10.0003 3.16663C12.4366 3.16663 14.4173 4.24364 15.8765 5.46153C17.3334 6.67745 18.3304 8.08161 18.8294 8.87167C18.8361 8.8823 18.8431 8.8933 18.8504 8.90468C18.9481 9.05825 19.0896 9.2807 19.1606 9.59036C19.2182 9.8415 19.2182 10.1584 19.1606 10.4096C19.0896 10.7192 18.9481 10.9417 18.8504 11.0952C18.8431 11.1066 18.8361 11.1176 18.8294 11.1282C18.3304 11.9183 17.3334 13.3225 15.8765 14.5384C14.4173 15.7563 12.4366 16.8333 10.0003 16.8333C7.56408 16.8333 5.58339 15.7563 4.12416 14.5384C2.66729 13.3225 1.67023 11.9183 1.17127 11.1282C1.16455 11.1176 1.15755 11.1066 1.15031 11.0952C1.05259 10.9417 0.911025 10.7192 0.840047 10.4096C0.782484 10.1584 0.782484 9.8415 0.840047 9.59036C0.911026 9.2807 1.05259 9.05825 1.15031 8.90468C1.15755 8.8933 1.16455 8.8823 1.17127 8.87167C1.67023 8.08161 2.66729 6.67745 4.12416 5.46153ZM10.0003 8.49996C9.17191 8.49996 8.50034 9.17153 8.50034 9.99996C8.50034 10.8284 9.17191 11.5 10.0003 11.5C10.8288 11.5 11.5003 10.8284 11.5003 9.99996C11.5003 9.17153 10.8288 8.49996 10.0003 8.49996ZM6.50034 9.99996C6.50034 8.06696 8.06734 6.49996 10.0003 6.49996C11.9333 6.49996 13.5003 8.06696 13.5003 9.99996C13.5003 11.933 11.9333 13.5 10.0003 13.5C8.06734 13.5 6.50034 11.933 6.50034 9.99996Z" fill="currentColor"/></svg></div>';
  var ICON_ADDCART = '<div class="icon-product"><svg xmlns="http://www.w3.org/2000/svg" width="9" height="8" viewBox="0 0 9 8" fill="none"><path d="M3.5 0H5.5V8H3.5V0Z" fill="currentColor"/><path d="M0.5 5L0.5 3L8.5 3V5L0.5 5Z" fill="currentColor"/></svg></div>';
  var SPINNER = '<div class="spinner"><svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle></svg></div>';
  // Chevron natif EXACT (2 demi-branches) : la CSS du theme le transforme en "−" quand ap-expanded-aria="true"
  var CHEVRON = '<svg aria-hidden="true" focusable="false" width="8" height="6" viewBox="0 0 8 6" fill="none" class="icon-chevron-down"><path class="icon-chevron-down-left" d="M4 4.5L7 1.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="square"></path><path class="icon-chevron-down-right" d="M4 4.5L1 1.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="square"></path></svg>';
  var CLOSE_SVG = '<svg focusable="false" width="14" height="14" class="icon icon--close" viewBox="0 0 14 14"><path d="M13 13L1 1M13 1L1 13" stroke="currentColor" stroke-width="2" fill="none"></path></svg>';

  var SRCSET_WIDTHS = [165, 360, 533, 720, 940, 1066];
  // Fleche de pagination native (icon-caret) + plafond de comptage
  var CARET = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>';
  var CAP_IDS = 6000; // au-dela, on affiche "X+" (filtre tres large type estado seul sur 25k)
  var COUNT_LOADING = '<span class="cf-count-spin" role="status" aria-label="Cargando"></span>'; // indicateur pendant le comptage

  // ---------------------------------------------------------------------------
  // Rendu d'une carte — clone EXACT de snippets/product-grid.liquid
  // ---------------------------------------------------------------------------
  function buildSrcset(url, mw) { var out = []; for (var i = 0; i < SRCSET_WIDTHS.length; i++) { if (mw >= SRCSET_WIDTHS[i]) out.push(imgUrl(url, SRCSET_WIDTHS[i]) + ' ' + SRCSET_WIDTHS[i] + 'w'); } if (url) out.push(imgUrl(url, mw) + ' ' + mw + 'w'); return out.join(', '); }
  function pickVariant(p) { var vs = (p.variants && p.variants.nodes) || []; for (var i = 0; i < vs.length; i++) if (vs[i].availableForSale) return vs[i]; return vs[0] || null; }

  function renderCard(p) {
    var id = gidNum(p.id), url = '/products/' + p.handle, variant = pickVariant(p), available = !!p.availableForSale;
    var price = variant && variant.price ? variant.price.amount : (p.priceRange && p.priceRange.minVariantPrice.amount);
    var compareAt = variant && variant.compareAtPrice ? variant.compareAtPrice.amount : (p.compareAtPriceRange && p.compareAtPriceRange.minVariantPrice ? p.compareAtPriceRange.minVariantPrice.amount : null);
    var onSale = compareAt && parseFloat(compareAt) > parseFloat(price);
    var images = (p.images && p.images.nodes) || [], img1 = images[0] || p.featuredImage || null, img2 = images[1] || null;
    var sizes = '(min-width: ' + cfg.settings.pageWidth + 'px) ' + Math.floor((cfg.settings.pageWidth - 100) / 2) + 'px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)';

    var labels = '';
    if (!available || onSale) {
      labels += '<div class="product-item__label-list label-list label-list-sale">';
      if (!available) labels += '<span class="label label--subdued">' + esc(cfg.strings.soldOut) + '</span>';
      if (onSale && available && cfg.settings.saleLabel) { var pct = Math.round((parseFloat(compareAt) - parseFloat(price)) * 100 / parseFloat(compareAt)); labels += '<div class="label label--highlight" aria-hidden="true">' + (cfg.settings.saleLayoutText ? esc(cfg.settings.saleText) : '-' + pct + '%') + '</div>'; }
      labels += '</div>';
    }
    var imgHtml = '';
    if (img1 && img1.url) {
      imgHtml += '<img class="product-item__primary-image" loading="lazy" alt="' + esc(p.title) + '" sizes="' + esc(sizes) + '" src="' + esc(imgUrl(img1.url, img1.width || 533)) + '" data-srcset="' + esc(buildSrcset(img1.url, img1.width || 533)) + '" width="' + (img1.width || '') + '" height="' + (img1.height || '') + '">';
      var second = img2 || img1;
      imgHtml += '<img class="product-item__secondary-image" loading="lazy" alt="' + esc(p.title) + '" sizes="' + esc(sizes) + '" src="' + esc(imgUrl(second.url, 800)) + '" data-srcset="' + esc(buildSrcset(second.url, second.width || 533)) + '" width="' + (second.width || '') + '" height="' + (second.height || '') + '">';
    } else { imgHtml += '<div class="placeholder-svg" style="aspect-ratio:1/1;background:#f2f2f2"></div>'; }

    var priceHtml = '<div class="product-item-meta__price-list-container">';
    if (available) {
      priceHtml += '<div class="price-list' + (onSale ? ' price-sale' : '') + '">';
      if (onSale) priceHtml += '<span class="price"><span class="visually-hidden">Sale price</span>' + money(price) + '</span><span class="price price--compare"><span class="visually-hidden">Regular price</span>' + money(compareAt) + '</span>';
      else priceHtml += '<span class="price"><span class="visually-hidden">Regular price</span>' + money(price) + '</span>';
      priceHtml += '</div>';
    } else priceHtml += esc(cfg.strings.soldOut);
    priceHtml += '</div>';

    var ratingHtml = (cfg.settings.enableRating && p.ratingBadge && p.ratingBadge.value) ? '<div class="jdgm-widget jdgm-preview-badge" data-id="' + id + '">' + p.ratingBadge.value + '</div>' : '';

    var cartHtml;
    if (available && variant) {
      cartHtml = '<form method="post" action="/cart/add" id="ap-productform-' + esc(cfg.sectionId) + '-' + id + '" accept-charset="UTF-8" class="shopify-ap-productform" enctype="multipart/form-data" is="ap-productform">' +
        '<input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="id" value="' + gidNum(variant.id) + '">' +
        '<button is="loader-button" type="submit" class="button button--outline button--text button--full"><span class="ap-text-loaderbutton">' + ICON_ADDCART + esc(cfg.strings.addToCart) + '</span><span class="ap-loader-loaderbutton" hidden="">' + SPINNER + '</span></button>' +
        '<button type="submit" class="product-item__quick-buy-button hd-no-touch"><span class="visually-hidden">' + ICON_ADDCART + '</span><svg focusable="false" width="22" height="21" class="icon icon--quick-buy" fill="none" viewBox="0 0 22 21"><path d="M12 4H3L2 20H18C17.7517 16.0273 17.375 10 17.375 10" stroke="currentColor" stroke-width="2"></path><path d="M7 7V7C7 8.65685 8.34315 10 10 10V10C11.6569 10 13 8.65685 13 7V7" stroke="currentColor" stroke-width="2"></path><path d="M18 0V8M14 4H22" stroke="currentColor" stroke-width="2"></path></svg></button>' +
        '</form>';
    } else cartHtml = '<button class="sold-out"><span class="ml-2">' + esc(cfg.strings.soldOut) + '</span></button>';

    return '<product-item class="slider__item " reveal="" style="opacity: 1;" id="product-item-' + id + '">' +
      '<div class="product-item-bg_wrapper h-100" style="background-color: var(--background-product);position: relative;"><div class="product-item-wrapper"><span class="product-line"></span>' +
      '<div class="product-item__image-wrapper product-item__image-wrapper--multiple">' + labels +
      '<a href="' + esc(url) + '" class="product-item__aspect-ratio aspect-ratio " style="padding-bottom: 100.0%; --aspect-ratio: ' + esc(cfg.settings.sizeImg) + '">' + imgHtml + '</a>' +
      '<div title="Guardar en Favoritos"><ap-wishlistbutton class="btn-service btn-wishlist" data-action="add" data-id="' + id + '" alt="Guardar en favoritos" onclick="setTimeout(() => location.reload(), 800)">' + ICON_WISHLIST + '</ap-wishlistbutton><span class="text-name d-none">Guardar en favoritos</span></div>' +
      '<div class="service-product"><div title="Quickview"><div class="btn-service btn-quickview"><div class="product-item__quick-form"><button is="toggle-button" loader="" ap-controlsaria="product-' + esc(cfg.sectionId) + '-' + id + '-drawer" ap-expanded-aria="false" class="button button--outline button--text button--full"><span class="ap-text-loaderbutton">' + ICON_QUICKVIEW + '</span><span class="ap-loader-loaderbutton" hidden="">' + SPINNER + '</span></button></div></div><span class="text-name d-lg-block d-none">Vista rápida</span></div></div>' +
      '</div>' +
      '<div class="product-item__info  "><div class="product-item-meta">' + ratingHtml +
      '<a href="' + esc(url) + '" class="product-item-meta__title mb-1">' + esc(truncateWords(p.title, 10)) + '</a>' +
      '<div class="product-price">' + priceHtml + '</div>' +
      '<div class="product-quantity-cart"><div class="service-add-cart w-100"><div title="Añadir a la cesta" class="btn-service btn-addcart">' + cartHtml + '</div><span class="text-name">Añadir</span></div></div>' +
      '</div></div></div></div></product-item>' +
      '<ap-quickbuy id="product-' + esc(cfg.sectionId) + '-' + id + '-drawer" href="/products/' + esc(p.handle) + '?view=quick-buy-drawer" class="drawer drawer--large drawer--quick-buy hd-phone"></ap-quickbuy>';
  }

  var CARD_FIELDS = 'id handle title availableForSale featuredImage { url width height } images(first: 2) { nodes { url width height } } priceRange { minVariantPrice { amount } } compareAtPriceRange { minVariantPrice { amount } } variants(first: 10) { nodes { id availableForSale price { amount } compareAtPrice { amount } } } ' + (cfg.settings.enableRating ? 'ratingBadge: metafield(namespace: "judgeme", key: "badge") { value } ' : '');

  // ---------------------------------------------------------------------------
  // Filtre Storefront <-> parametre URL natif (filter.*)
  // ---------------------------------------------------------------------------
  function inputToUrl(input) {
    if ('available' in input) return { key: 'filter.v.availability', value: input.available ? '1' : '0' };
    if (input.variantOption) return { key: 'filter.v.option.' + input.variantOption.name.toLowerCase(), value: input.variantOption.value };
    if (input.productMetafield) return { key: 'filter.p.m.' + input.productMetafield.namespace + '.' + input.productMetafield.key, value: input.productMetafield.value };
    if (input.productTag) return { key: 'filter.p.tag', value: input.productTag };
    if (input.productType) return { key: 'filter.p.product_type', value: input.productType };
    if (input.productVendor) return { key: 'filter.p.vendor', value: input.productVendor };
    return null;
  }

  // ===========================================================================
  // Etat + controleur
  // ===========================================================================
  var state = { filters: [], price: null, sort: null, allIds: [], page: 1, hasMore: false, counting: false, loading: false, exactCount: null, exactCapped: false };
  var loadToken = 0;
  var loadTimer = null;
  var root, grid, listContainer, filterListEl, activeTagsEl, panelEl, countEl, paginationEl, nativePagination;
  var nativeCountText = '';
  var priceMax = 200;

  function hasActiveFilters() { return state.filters.length > 0 || (state.price && (state.price.min != null || state.price.max != null)); }
  function setLoading(on) { state.loading = on; if (grid) grid.style.opacity = on ? '0.5' : '1'; }

  var apiMode = false;
  function enterApiMode() {
    if (apiMode) return;
    apiMode = true;
    if (nativePagination) nativePagination.style.display = 'none';
    var nl = document.getElementById('ap_loadmoreproduct'); if (nl) nl.style.display = 'none';
    // conteneur de pagination (remplace la grille native / le scroll infini)
    paginationEl = document.createElement('div');
    paginationEl.id = 'cf-pagination';
    if (grid && grid.parentNode) grid.parentNode.insertBefore(paginationEl, grid.nextSibling);
    else if (listContainer.parentNode) listContainer.parentNode.appendChild(paginationEl);
    paginationEl.addEventListener('click', function (e) {
      var a = e.target.closest('[data-cf-page]');
      if (!a) return;
      e.preventDefault();
      var n = parseInt(a.getAttribute('data-cf-page'), 10);
      if (n && n !== state.page && !state.loading) goToPage(n);
    });
  }

  function readSort() { var c = document.querySelector('input[name="sort_by"]:checked'); return mapSort(c ? c.value : (new URLSearchParams(location.search)).get('sort_by')); }
  function mapSort(v) {
    if (!v) return null;
    if (cfg.context === 'search') { if (v === 'price-ascending') return { key: 'PRICE', reverse: false }; if (v === 'price-descending') return { key: 'PRICE', reverse: true }; return null; }
    switch (v) {
      case 'best-selling': return { key: 'BEST_SELLING', reverse: false };
      case 'title-ascending': return { key: 'TITLE', reverse: false };
      case 'title-descending': return { key: 'TITLE', reverse: true };
      case 'price-ascending': return { key: 'PRICE', reverse: false };
      case 'price-descending': return { key: 'PRICE', reverse: true };
      case 'created-ascending': return { key: 'CREATED', reverse: false };
      case 'created-descending': case 'created': return { key: 'CREATED', reverse: true };
      default: return null;
    }
  }

  function buildFilters() {
    var arr = state.filters.slice();
    if (state.price && (state.price.min != null || state.price.max != null)) {
      var pr = {};
      if (state.price.min != null) pr.min = state.price.min;
      if (state.price.max != null) pr.max = state.price.max;
      arr.push({ price: pr });
    }
    return arr;
  }

  // Filtres SANS la disponibilite (pour pouvoir LIRE le compteur de la facette dispo)
  function nonAvailFilters() { return buildFilters().filter(function (f) { return !('available' in f); }); }
  // Disponibilite selectionnee : true (Disponible), false (Agotado) ou null (aucune contrainte)
  function selectedAvail() { var v = null; state.filters.forEach(function (f) { if ('available' in f) v = f.available; }); return v; }

  // COMPTEUR RAPIDE ET EXACT : au lieu de paginer des milliers d'ids (~3s), on lit le compteur
  // de la facette "disponibilite" en 1 requete (~0,5s). La valeur "En existencia" est <=5000
  // (max ~2754 dispo sur ce catalogue) donc EXACTE. Independant de la pagination (qui charge en fond).
  function fetchExactCount(token) {
    if (cfg.context === 'search') return; // pas de facettes en recherche
    var q = 'query($handle:String!,$filters:[ProductFilter!]){ collection(handle:$handle){ products(first:1, filters:$filters){ filters{ id label values{ label count } } } } }';
    gql(q, { handle: cfg.collectionHandle, filters: nonAvailFilters() }).then(function (d) {
      if (token !== loadToken) return;
      var fs = (d && d.collection && d.collection.products.filters) || [];
      var af = fs.filter(function (f) { return (f.id || '').indexOf('availability') !== -1; })[0];
      if (!af || !af.values) return;
      var availV = 0, soldV = 0;
      af.values.forEach(function (v) {
        if (/existencia|in\s*stock/i.test(v.label)) availV = v.count;
        else if (/agotado|sold|out\s*of\s*stock/i.test(v.label)) soldV = v.count;
      });
      var sel = selectedAvail(), n, capped;
      if (sel === true) { n = availV; capped = availV >= 5000; }
      else if (sel === false) { n = soldV; capped = soldV >= 5000; }
      else { n = availV + soldV; capped = soldV >= 5000; } // aucune contrainte dispo
      state.exactCount = n; state.exactCapped = capped;
      updateCount();
    }).catch(function () { /* repli : le comptage par pagination prend le relais */ });
  }

  // Anti-rebond : on coalesce les clics rapides en un seul chargement (evite le spinner
  // perpetuel + les rafales de requetes qui font "planter" le compteur).
  function scheduleLoad() {
    if (loadTimer) clearTimeout(loadTimer);
    state.counting = true; state.exactCount = null; updateCount(); renderPagination();
    loadTimer = setTimeout(function () { loadTimer = null; loadFiltered(); }, 300);
  }

  // PHASE A : recupere PROGRESSIVEMENT tous les ids du resultat filtre -> total EXACT + ordre.
  // La page 1 s'affiche des le 1er lot ; le comptage se poursuit en arriere-plan.
  function loadFiltered() {
    enterApiMode();
    setLoading(true);
    state.allIds = [];
    state.hasMore = false;
    state.counting = true;
    state.exactCount = null; state.exactCapped = false;
    var filters = buildFilters(), sort = state.sort;
    var token = ++loadToken;
    fetchExactCount(token); // compteur exact rapide (facette), en parallele de la pagination
    function fetchIds(after) {
      if (cfg.context === 'search') {
        var sq = 'query($q:String!,$first:Int!,$after:String,$filters:[ProductFilter!]' + (sort ? ',$sortKey:SearchSortKeys,$reverse:Boolean' : '') + '){search(query:$q,first:$first,after:$after,types:PRODUCT,productFilters:$filters' + (sort ? ',sortKey:$sortKey,reverse:$reverse' : '') + '){pageInfo{hasNextPage endCursor} edges{node{... on Product{ id }}}}}';
        var sv = { q: cfg.searchTerms, first: 250, after: after, filters: filters };
        if (sort) { sv.sortKey = sort.key; sv.reverse = sort.reverse; }
        return gql(sq, sv).then(function (d) { var c = d && d.search; return { ids: c ? c.edges.map(function (e) { return e.node && e.node.id; }).filter(Boolean) : [], next: c ? c.pageInfo.hasNextPage : false, cursor: c ? c.pageInfo.endCursor : null }; });
      }
      var cq = 'query($handle:String!,$first:Int!,$after:String,$filters:[ProductFilter!]' + (sort ? ',$sortKey:ProductCollectionSortKeys,$reverse:Boolean' : '') + '){collection(handle:$handle){products(first:$first,after:$after,filters:$filters' + (sort ? ',sortKey:$sortKey,reverse:$reverse' : '') + '){pageInfo{hasNextPage endCursor} nodes{ id }}}}';
      var cv = { handle: cfg.collectionHandle, first: 250, after: after, filters: filters };
      if (sort) { cv.sortKey = sort.key; cv.reverse = sort.reverse; }
      return gql(cq, cv).then(function (d) { var c = d && d.collection && d.collection.products; return { ids: c ? c.nodes.map(function (n) { return n.id; }) : [], next: c ? c.pageInfo.hasNextPage : false, cursor: c ? c.pageInfo.endCursor : null }; });
    }
    function step(after, first, tries) {
      return fetchIds(after).then(function (r) {
        if (token !== loadToken) return; // un nouveau filtre a ete applique -> abandon
        state.allIds = state.allIds.concat(r.ids);
        if (first) { state.page = 1; goToPage(1, true); } // page 1 tout de suite (compteur masque, pagination masquee)
        if (r.next && state.allIds.length < CAP_IDS) return step(r.cursor, false, 0);
        // plafond dur Shopify : un filtre de variante (estado) utilise SANS "disponible"
        // plafonne a 5000 resultats -> on signale avec "+" pour ne pas afficher un total faux.
        var hasVarOpt = filters.some(function (f) { return f.variantOption; });
        var hasAvail = filters.some(function (f) { return f.available === true; });
        var variantCapped = hasVarOpt && !hasAvail && state.allIds.length >= 5000;
        state.hasMore = r.next || variantCapped; state.counting = false;
        updateCount(); renderPagination();
      }).catch(function () {
        if (token !== loadToken) return;
        if ((tries || 0) < 2) return new Promise(function (res) { setTimeout(res, 800); }).then(function () { return step(after, first, (tries || 0) + 1); });
        state.hasMore = true; state.counting = false;
        if (first) { state.page = 1; goToPage(1, true); } else { updateCount(); renderPagination(); }
      });
    }
    return step(null, true, 0);
  }

  // PHASE B : rend une page precise (48 produits) a partir des ids stockes
  function goToPage(n, noScroll) {
    var total = Math.max(1, Math.ceil(state.allIds.length / PER_PAGE));
    n = Math.min(Math.max(1, n), total);
    state.page = n;
    var ids = state.allIds.slice((n - 1) * PER_PAGE, n * PER_PAGE);
    if (!ids.length) { renderProducts([]); renderPagination(); updateCount(); setLoading(false); return Promise.resolve(); }
    setLoading(true);
    return gql('query($ids:[ID!]!){nodes(ids:$ids){... on Product{ ' + CARD_FIELDS + ' }}}', { ids: ids }).then(function (d) {
      renderProducts((d && d.nodes ? d.nodes : []).filter(Boolean));
      renderPagination();
      updateCount();
      setLoading(false);
      if (grid) grid.setAttribute('data-cf-loaded', state.allIds.length);
      if (!noScroll) scrollToResults();
    }).catch(function (e) { console.error('[custom-filters] goToPage', e); setLoading(false); });
  }

  function renderProducts(nodes) {
    if (!listContainer) return;
    listContainer.innerHTML = nodes.length ? nodes.map(renderCard).join('') : '<p class="cf-empty">' + esc(cfg.strings.noResults) + '</p>';
  }

  function updateCount() {
    if (!countEl) return;
    if (cfg.context === 'search') return; // recherche : libelle natif conserve
    if (!hasActiveFilters()) { if (nativeCountText) countEl.textContent = nativeCountText; return; }
    // 1) compteur exact rapide (facette) des qu'il est connu, meme si la pagination charge encore
    if (state.exactCount != null) { countEl.textContent = state.exactCount + (state.exactCapped ? '+' : '') + ' ' + (cfg.strings.productsWord || 'productos'); return; }
    // 2) sinon, pendant le comptage : indicateur de chargement (pas de chiffre qui grimpe)
    if (state.counting) { countEl.innerHTML = COUNT_LOADING; return; }
    // 3) repli : total issu de la pagination des ids
    countEl.textContent = state.allIds.length + (state.hasMore ? '+' : '') + ' ' + (cfg.strings.productsWord || 'productos');
  }

  function scrollToResults() {
    var anchor = document.getElementById('facet-main') || grid;
    if (anchor && anchor.scrollIntoView) { try { anchor.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { anchor.scrollIntoView(); } }
  }

  // Pagination numerotee, markup identique au natif (snippet pagination.liquid + component-pagination.css)
  function pageParts(cur, total) {
    var pages = [], parts = [], prev = 0, win = 1;
    for (var i = 1; i <= total; i++) { if (i === 1 || i === total || (i >= cur - win && i <= cur + win)) pages.push(i); }
    pages.forEach(function (p) { if (p - prev > 1) parts.push('...'); parts.push(p); prev = p; });
    return parts;
  }
  function renderPagination() {
    if (!paginationEl) return;
    if (state.counting) { paginationEl.innerHTML = ''; return; } // masquee tant que le total n'est pas connu
    var total = Math.max(1, Math.ceil(state.allIds.length / PER_PAGE));
    if (total <= 1) { paginationEl.innerHTML = ''; return; }
    var cur = state.page;
    var h = '<div class="pagination-wrapper"><nav class="pagination" role="navigation" aria-label="Pagination"><ul class="pagination__list list-unstyled" role="list">';
    if (cur > 1) h += '<li><a href="#" class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce" data-cf-page="' + (cur - 1) + '" aria-label="Anterior">' + CARET + '</a></li>';
    pageParts(cur, total).forEach(function (p) {
      if (p === '...') h += '<li><span class="pagination__item">...</span></li>';
      else if (p === cur) h += '<li><a role="link" aria-disabled="true" class="pagination__item pagination__item--current light" ap-currentaria="page">' + p + '</a></li>';
      else h += '<li><a href="#" class="pagination__item link" data-cf-page="' + p + '">' + p + '</a></li>';
    });
    if (cur < total) h += '<li><a href="#" class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce" data-cf-page="' + (cur + 1) + '" aria-label="Siguiente">' + CARET + '</a></li>';
    paginationEl.innerHTML = h + '</ul></nav></div>';
  }

  function syncUrl() {
    var params = new URLSearchParams();
    if (cfg.context === 'search') { params.set('q', cfg.searchTerms); params.set('type', 'product'); }
    state.filters.forEach(function (f) { var u = inputToUrl(f); if (u) params.append(u.key, u.value); });
    if (state.price) { if (state.price.min != null) params.set('filter.v.price.gte', state.price.min); if (state.price.max != null) params.set('filter.v.price.lte', state.price.max); }
    var si = document.querySelector('input[name="sort_by"]:checked'); if (si && si.value) params.set('sort_by', si.value);
    var cur = new URLSearchParams(location.search);
    ['preview_theme_id', '_fd', 'pb'].forEach(function (k) { if (cur.has(k)) params.set(k, cur.get(k)); });
    var qs = params.toString();
    history.replaceState(null, '', location.pathname + (qs ? '?' + qs : ''));
  }

  function readPrice() {
    var mn = filterListEl.querySelector('[data-cf-price-min]'), mx = filterListEl.querySelector('[data-cf-price-max]');
    var pmin = mn && mn.value !== '' ? parseFloat(mn.value) : null;
    var pmax = mx && mx.value !== '' ? parseFloat(mx.value) : null;
    // plein interval => pas de filtre
    if (pmin != null && pmin <= 0) pmin = null;
    if (pmax != null && pmax >= priceMax) pmax = null;
    return (pmin != null || pmax != null) ? { min: pmin, max: pmax } : null;
  }

  // Inputs coches qui imposent VRAIMENT une contrainte. Un groupe entierement coche
  // (ex: les 4 etats) = "tout selectionne" = aucune preference => on l'omet. Ca evite le
  // plafond de 5000 du filtre variante (estado) et donne le vrai ensemble complet.
  function effectiveCheckedInputs() {
    var out = [];
    filterListEl.querySelectorAll('.cf-filter-item').forEach(function (grp) {
      var inputs = grp.querySelectorAll('input[data-cf-input]');
      if (!inputs.length) return;
      var checked = grp.querySelectorAll('input[data-cf-input]:checked');
      if (checked.length === inputs.length) return; // groupe 100% coche => pas de contrainte
      for (var i = 0; i < checked.length; i++) out.push(checked[i]);
    });
    return out;
  }

  function apply() {
    state.filters = [];
    effectiveCheckedInputs().forEach(function (input) { try { state.filters.push(JSON.parse(input.getAttribute('data-cf-input'))); } catch (e) {} });
    state.price = readPrice();
    state.sort = readSort();
    // aucune contrainte reelle (tout coche / rien coche, pas de prix) => vue propre native complete
    if (!state.filters.length && !state.price) { clearAll(); return; }
    syncUrl();
    renderActiveTags();
    scheduleLoad();
  }

  // ---------------------------------------------------------------------------
  // UI des facettes — REUTILISE les coquilles natives (toggle-button + ap-contentcollapsible)
  // ---------------------------------------------------------------------------
  var grpSeq = 0;
  function collapsibleFilterItem(label, innerHtml) {
    var id = 'cf-grp-' + (grpSeq++);
    return '<div class="ap-productfacet__filter-item cf-filter-item">' +
      '<button type="button" is="toggle-button" class="collapsible-toggle text--strong" ap-controlsaria="' + id + '" ap-expanded-aria="true">' + esc(label) + CHEVRON + '</button>' +
      '<ap-contentcollapsible id="' + id + '" class="collapsible" open animate-items="">' +
      '<div class="collapsible__content">' + innerHtml + '</div>' +
      '</ap-contentcollapsible></div>';
  }

  function availLabel(l) { return /existencia|in\s*stock/i.test(l) ? cfg.strings.available : l; }

  function checkboxRow(groupKey, filterKey, idx, value) {
    var inputObj; try { inputObj = JSON.parse(value.input); } catch (e) { inputObj = null; }
    if (!inputObj) return '';
    var id = 'cf-' + filterKey + '-' + idx;
    var label = groupKey === 'availability' ? availLabel(value.label) : value.label;
    return '<div class="checkbox-container"' + (idx >= 8 ? ' data-show-more-item style="display:none"' : '') + '>' +
      '<input class="checkbox" type="checkbox" id="' + esc(id) + '" data-cf-input=\'' + esc(value.input) + '\'>' +
      '<label for="' + esc(id) + '">' + esc(label) + '</label></div>';
  }

  function listFilterHtml(filter, groupKey) {
    var vals = filter.values || [], rows = '';
    for (var i = 0; i < vals.length; i++) rows += checkboxRow(groupKey, filter.id || groupKey, i, vals[i]);
    var more = vals.length > 8 ? '<button type="button" class="filter-show-more-btn link text--subdued" data-show-more-btn><span class="label-more">+ Ver más (' + (vals.length - 8) + ')</span><span class="label-less" style="display:none">- Ver menos</span></button>' : '';
    var search = vals.length > 12 ? '<input type="text" class="input__field cf-facet-search" placeholder="' + esc(cfg.strings.searchIn) + ' ' + esc((filter.label || groupKey).toLowerCase()) + '..." data-cf-facet-search>' : '';
    return search + rows + more;
  }

  function priceFilterHtml(max) {
    max = Math.ceil(max || 200);
    priceMax = max;
    return '<div class="ap-pricerange cf-pricerange">' +
      '<div class="ap-pricerange__range-group range-group" style="--range-min: 0%; --range-max: 100%">' +
      '<input type="range" aria-label="From price" class="range" min="0" max="' + max + '" value="0" data-cf-range-min>' +
      '<input type="range" aria-label="To price" class="range" min="0" max="' + max + '" value="' + max + '" style="z-index:0;" data-cf-range-max>' +
      '</div>' +
      '<div class="ap-pricerange__input-group">' +
      '<div class="ap-pricerange__input input-prefix text--xsmall"><span class="input-prefix__value text--subdued">€</span><input aria-label="From price" class="input-prefix__field" type="number" inputmode="numeric" value="0" min="0" max="' + max + '" placeholder="0" data-cf-price-min></div>' +
      '<span class="ap-pricerange__delimiter text--small">a</span>' +
      '<div class="ap-pricerange__input input-prefix text--xsmall"><span class="input-prefix__value text--subdued">€</span><input aria-label="To price" class="input-prefix__field" type="number" inputmode="numeric" value="' + max + '" min="0" max="' + max + '" placeholder="' + max + '" data-cf-price-max></div>' +
      '</div></div>';
  }

  // Ordre demande : Disponibilite > Estado > Precio > Autor > Editorial
  var LABELS = { availability: 'Disponibilidad', estado: 'Estado', author: 'Autor', publisher: 'Edición' };
  function renderGroups(groups) {
    grpSeq = 0;
    var order = ['availability', 'estado', 'price', 'author', 'publisher'], html = '';
    order.forEach(function (key) {
      if (key === 'price') { html += collapsibleFilterItem(cfg.strings.price, priceFilterHtml(priceMax)); return; }
      var f = groups[key];
      if (f && f.values && f.values.length) html += collapsibleFilterItem((groups[key].label) || LABELS[key] || key, listFilterHtml(f, key));
    });
    filterListEl.innerHTML = html;
  }

  // Borne max du prix : lue depuis la facette PRICE_RANGE (fiable, non plafonnee)
  function priceMaxFromFacets(fs) {
    var pf = (fs || []).filter(function (f) { return (f.id || '').indexOf('price') !== -1; })[0];
    if (pf && pf.values && pf.values[0]) { try { var inp = JSON.parse(pf.values[0].input); if (inp.price && inp.price.max) return Math.ceil(inp.price.max); } catch (e) {} }
    return 200;
  }

  // Depuis les facettes API d'une collection
  function groupsFromApi(apiFilters) {
    var g = {};
    (apiFilters || []).forEach(function (f) {
      var id = f.id || '';
      if (id.indexOf('availability') !== -1) g.availability = { values: f.values, label: LABELS.availability };
      else if (id.indexOf('option') !== -1) g.estado = { values: f.values, label: LABELS.estado };
      else if (id.indexOf('book_author') !== -1) g.author = { values: f.values, label: LABELS.author };
      else if (id.indexOf('book_publisher') !== -1) g.publisher = { values: f.values, label: LABELS.publisher };
    });
    return g;
  }

  // Repli : filtres CONNUS (dispo + estado + prix) quand l'API ne repond pas.
  // Garantit qu'on n'affiche JAMAIS que le prix, meme si le fetch des facettes echoue.
  function fixedGroups() {
    return {
      availability: { label: LABELS.availability, values: [
        { label: cfg.strings.available, count: 0, input: '{"available":true}' },
        { label: 'Agotado', count: 0, input: '{"available":false}' }
      ] },
      estado: { label: LABELS.estado, values: ['Aceptable', 'Bueno', 'Muy bueno', 'Como nuevo'].map(function (e) {
        return { label: e, count: 0, input: JSON.stringify({ variantOption: { name: 'Estado', value: e } }) };
      }) }
    };
  }

  // Facettes pour la recherche : dispo + estado fixes, auteur/editorial derives d'un echantillon
  function groupsForSearch(sampleNodes) {
    var g = {};
    g.availability = { label: LABELS.availability, values: [
      { label: cfg.strings.available, count: 0, input: '{"available":true}' },
      { label: 'Agotado', count: 0, input: '{"available":false}' }
    ] };
    g.estado = { label: LABELS.estado, values: ['Aceptable', 'Bueno', 'Muy bueno', 'Como nuevo'].map(function (e) { return { label: e, count: 0, input: JSON.stringify({ variantOption: { name: 'Estado', value: e } }) }; }) };
    // agrege auteurs / editoriaux de l'echantillon
    function agg(nodes, key) {
      var map = {};
      nodes.forEach(function (n) { var v = n[key] && n[key].value; if (v) map[v] = (map[v] || 0) + 1; });
      return Object.keys(map).sort(function (a, b) { return map[b] - map[a] || a.localeCompare(b); })
        .map(function (label) { return { label: label, count: map[label], input: JSON.stringify(key === 'author' ? { productMetafield: { namespace: 'custom', key: 'book_author', value: label } } : { productMetafield: { namespace: 'custom', key: 'book_publisher', value: label } }) }; });
    }
    var authors = agg(sampleNodes, 'author'), publishers = agg(sampleNodes, 'publisher');
    if (authors.length) g.author = { label: LABELS.author, values: authors };
    if (publishers.length) g.publisher = { label: LABELS.publisher, values: publishers };
    return g;
  }

  // ---------------------------------------------------------------------------
  // Slider de prix (markup natif .ap-pricerange, mais notre propre sync)
  // ---------------------------------------------------------------------------
  function wirePriceSlider() {
    var box = filterListEl.querySelector('.cf-pricerange'); if (!box) return;
    var group = box.querySelector('.ap-pricerange__range-group');
    var rMin = box.querySelector('[data-cf-range-min]'), rMax = box.querySelector('[data-cf-range-max]');
    var nMin = box.querySelector('[data-cf-price-min]'), nMax = box.querySelector('[data-cf-price-max]');
    var max = parseFloat(rMin.max) || priceMax;
    function setVars() { group.style.setProperty('--range-min', (parseFloat(rMin.value) / max * 100) + '%'); group.style.setProperty('--range-max', (parseFloat(rMax.value) / max * 100) + '%'); }
    function fromRange(which) {
      var lo = parseFloat(rMin.value), hi = parseFloat(rMax.value);
      if (lo > hi) { if (which === 'min') { lo = hi; rMin.value = lo; } else { hi = lo; rMax.value = hi; } }
      nMin.value = lo; nMax.value = hi; setVars();
    }
    function fromNumber() {
      var lo = clamp(parseFloat(nMin.value) || 0, 0, max), hi = clamp(parseFloat(nMax.value) || max, 0, max);
      if (lo > hi) lo = hi;
      rMin.value = lo; rMax.value = hi; nMin.value = lo; nMax.value = hi; setVars();
    }
    rMin.addEventListener('input', function () { fromRange('min'); });
    rMax.addEventListener('input', function () { fromRange('max'); });
    rMin.addEventListener('change', apply);
    rMax.addEventListener('change', apply);
    nMin.addEventListener('change', function () { fromNumber(); apply(); });
    nMax.addEventListener('change', function () { fromNumber(); apply(); });
    box._cfSync = function () { fromNumber(); };
    setVars();
  }

  // ---------------------------------------------------------------------------
  // Tags actifs
  // ---------------------------------------------------------------------------
  function renderActiveTags() {
    if (!activeTagsEl) return;
    var tags = '';
    effectiveCheckedInputs().forEach(function (input) {
      var lab = filterListEl.querySelector('label[for="' + input.id + '"]');
      var label = lab ? lab.textContent.replace(/\s*\(\d+\)\s*$/, '').trim() : '';
      tags += '<div class="tag" data-cf-tag-for="' + input.id + '"><a href="#" class="tag__icon tap-area" data-cf-remove="' + input.id + '" aria-label="Delete"><svg focusable="false" width="10" height="10" class="icon icon--close" viewBox="0 0 14 14"><path d="M13 13L1 1M13 1L1 13" stroke="currentColor" stroke-width="2" fill="none"></path></svg></a>' + esc(label) + '</div>';
    });
    if (state.price && (state.price.min != null || state.price.max != null)) {
      var lo = state.price.min != null ? money(state.price.min) : money(0), hi = state.price.max != null ? money(state.price.max) : money(priceMax);
      tags += '<div class="tag" data-cf-tag-price><a href="#" class="tag__icon tap-area" data-cf-remove-price aria-label="Delete"><svg focusable="false" width="10" height="10" class="icon icon--close" viewBox="0 0 14 14"><path d="M13 13L1 1M13 1L1 13" stroke="currentColor" stroke-width="2" fill="none"></path></svg></a>' + lo + ' - ' + hi + '</div>';
    }
    if (tags) tags += '<a href="#" class="tag-link link text--subdued" data-cf-clear-all>' + esc(cfg.strings.clearAll) + '</a>';
    activeTagsEl.innerHTML = tags;
  }

  // ---------------------------------------------------------------------------
  // URL -> panneau : on reflete les filtres de l'URL (cases + prix) dans le panneau.
  // ---------------------------------------------------------------------------
  function initFromUrl() {
    // On reflete TOUJOURS les filtres de l'URL dans le panneau (cases + prix), y compris une
    // dispo=1 venant de la nav categorie. Sans ca, ajouter un etat "perdait" la dispo et le
    // compteur montait au plafond (ex: 5000) au lieu du vrai sous-ensemble (ex: 432).
    var params = new URLSearchParams(location.search);
    var gte = params.get('filter.v.price.gte'), lte = params.get('filter.v.price.lte');
    var mn = filterListEl.querySelector('[data-cf-price-min]'), mx = filterListEl.querySelector('[data-cf-price-max]');
    if (gte != null && mn) mn.value = gte;
    if (lte != null && mx) mx.value = lte;
    if ((gte != null || lte != null)) { var box = filterListEl.querySelector('.cf-pricerange'); if (box && box._cfSync) box._cfSync(); }
    filterListEl.querySelectorAll('input[data-cf-input]').forEach(function (input) {
      var u; try { u = inputToUrl(JSON.parse(input.getAttribute('data-cf-input'))); } catch (e) { return; }
      if (u && params.getAll(u.key).indexOf(u.value) !== -1) input.checked = true;
    });
  }

  function domHasActiveFilters() {
    if (effectiveCheckedInputs().length) return true;
    return readPrice() != null;
  }

  // ---------------------------------------------------------------------------
  // Show-more + recherche interne de facette (etats independants)
  // ---------------------------------------------------------------------------
  function restoreShowMore(content) {
    var expanded = content.getAttribute('data-cf-expanded') === '1';
    content.querySelectorAll('.checkbox-container').forEach(function (row) {
      row.style.display = row.hasAttribute('data-show-more-item') ? (expanded ? 'block' : 'none') : '';
    });
    var btn = content.querySelector('[data-show-more-btn]');
    if (btn) { btn.style.display = ''; btn.querySelector('.label-more').style.display = expanded ? 'none' : 'inline'; btn.querySelector('.label-less').style.display = expanded ? 'inline' : 'none'; }
  }

  // ---------------------------------------------------------------------------
  // Wiring
  // ---------------------------------------------------------------------------
  function wire() {
    filterListEl.addEventListener('change', function (e) {
      if (e.target.matches('input[data-cf-input]')) apply();
    });
    filterListEl.addEventListener('click', function (e) {
      var moreBtn = e.target.closest('[data-show-more-btn]');
      if (moreBtn) {
        e.preventDefault();
        var content = moreBtn.closest('.collapsible__content');
        var expanded = content.getAttribute('data-cf-expanded') === '1';
        content.setAttribute('data-cf-expanded', expanded ? '0' : '1');
        content.querySelectorAll('[data-show-more-item]').forEach(function (el) { el.style.display = expanded ? 'none' : 'block'; });
        moreBtn.querySelector('.label-more').style.display = expanded ? 'inline' : 'none';
        moreBtn.querySelector('.label-less').style.display = expanded ? 'none' : 'inline';
      }
    });
    filterListEl.addEventListener('input', function (e) {
      if (!e.target.matches('[data-cf-facet-search]')) return;
      var q = e.target.value.toLowerCase().trim(), content = e.target.closest('.collapsible__content');
      var btn = content.querySelector('[data-show-more-btn]');
      if (q === '') { restoreShowMore(content); return; }
      if (btn) btn.style.display = 'none';
      content.querySelectorAll('.checkbox-container').forEach(function (row) {
        var lab = row.querySelector('label');
        row.style.display = (lab && lab.textContent.toLowerCase().indexOf(q) !== -1) ? '' : 'none';
      });
    });
    // clear-all (header drawer + tags), remove tag, remove price — delegue sur le panneau
    panelEl.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-cf-remove]');
      if (rm) { e.preventDefault(); var inp = document.getElementById(rm.getAttribute('data-cf-remove')); if (inp) { inp.checked = false; apply(); } return; }
      if (e.target.closest('[data-cf-remove-price]')) { e.preventDefault(); resetPriceInputs(); apply(); return; }
      if (e.target.closest('[data-cf-clear-all]')) { e.preventDefault(); clearAll(); }
    });
  }

  function resetPriceInputs() {
    var mn = filterListEl.querySelector('[data-cf-price-min]'), mx = filterListEl.querySelector('[data-cf-price-max]');
    if (mn) mn.value = 0; if (mx) mx.value = priceMax;
    var box = filterListEl.querySelector('.cf-pricerange'); if (box && box._cfSync) box._cfSync();
  }

  function clearAll() {
    var base = cfg.context === 'search' ? location.pathname + '?q=' + encodeURIComponent(cfg.searchTerms) + '&type=product' : location.pathname;
    var cur = new URLSearchParams(location.search), keep = [];
    ['preview_theme_id', '_fd', 'pb'].forEach(function (k) { if (cur.has(k)) keep.push(k + '=' + encodeURIComponent(cur.get(k))); });
    location.href = base + (keep.length ? (base.indexOf('?') === -1 ? '?' : '&') + keep.join('&') : '');
  }

  // ---------------------------------------------------------------------------
  // Bootstrap
  // ---------------------------------------------------------------------------
  function afterBuild() {
    wirePriceSlider();
    initFromUrl();
    wire();
    renderActiveTags();
    state.sort = readSort();
    try { document.documentElement.setAttribute('data-cf-ready', '1'); } catch (e) {}
    // Mode API des qu'un filtre est actif (dispo=1 de la nav incluse) : le compteur est alors
    // EXACT (dispo appliquee = ~2500 au lieu du 25001 natif non filtre) et l'ajout d'un etat
    // reste un sous-ensemble coherent. Collection sans aucun filtre => rendu natif instantane.
    if (domHasActiveFilters()) apply();
  }

  // ---------------------------------------------------------------------------
  // Drawer mobile : gere par NOUS (pas le composant natif) -> fiable sur tous
  // les navigateurs (iOS Safari inclus). Reutilise le CSS natif .drawer/.drawer--from-left.
  // ---------------------------------------------------------------------------
  function setupDrawer() {
    var el = document.getElementById('ap-facetfilters');
    if (!el || el._cfDrawer) return;
    el._cfDrawer = true;
    var mq = window.matchMedia('(max-width: 999px)');
    function openD() { if (mq.matches) { el.setAttribute('open', ''); document.documentElement.classList.add('ap-lockall'); } }
    function closeD() { el.removeAttribute('open'); document.documentElement.classList.remove('ap-lockall'); }
    function adjust() { var m = mq.matches; el.classList.toggle('drawer', m); el.classList.toggle('drawer--from-left', m); if (!m) closeD(); }
    if (mq.addEventListener) mq.addEventListener('change', adjust); else if (mq.addListener) mq.addListener(adjust);
    adjust();
    // ouverture par le(s) bouton(s) "Filtros" de la barre mobile
    document.querySelectorAll('.mobile-toolbar__item--filters').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); if (el.hasAttribute('open')) closeD(); else openD(); });
    });
    // fermeture : overlay, bouton close, Echap
    el.addEventListener('click', function (e) { if (e.target.classList.contains('drawer__overlay') || e.target.closest('[data-action="close"]')) { e.preventDefault(); closeD(); } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && el.hasAttribute('open')) closeD(); });
    window._cfCloseDrawer = closeD;
  }

  function boot() {
    root = document.querySelector('ap-productfacet') || document.body;
    panelEl = document.querySelector('.cf-panel') || root;
    filterListEl = document.getElementById('cf-filter-list');
    activeTagsEl = document.getElementById('cf-active-tags');
    grid = document.querySelector('ap-productlist');
    listContainer = document.getElementById('ap_productlist') || (grid ? grid.querySelector('.ap-productlist__inner') : null);
    countEl = document.querySelector('.ap-productfacet__meta-bar-item--count');
    if (countEl) nativeCountText = countEl.textContent.trim();
    nativePagination = document.querySelector('.ap-productfacet__main .pagination, #facet-main .pagination');
    setupDrawer(); // le drawer mobile doit marcher immediatement, meme pendant le chargement des filtres
    if (!filterListEl || !listContainer) { console.warn('[custom-filters] mount introuvable'); return; }

    if (cfg.context === 'search') {
      // echantillon pour deriver auteur / editorial (l'API search n'expose pas de facettes)
      var sq = 'query($q:String!){ search(query:$q, first:250, types:PRODUCT){ edges{ node{ ... on Product { author: metafield(namespace:"custom",key:"book_author"){ value } publisher: metafield(namespace:"custom",key:"book_publisher"){ value } } } } } }';
      gql(sq, { q: cfg.searchTerms }).then(function (d) {
        var nodes = (d && d.search) ? d.search.edges.map(function (e) { return e.node; }) : [];
        renderGroups(groupsForSearch(nodes));
        afterBuild();
      }).catch(function () { renderGroups(groupsForSearch([])); afterBuild(); });
    } else {
      var facetQ = 'query($handle:String!){ collection(handle:$handle){ products(first:1){ filters{ id label type values{ id label count input } } } } }';
      var tries = 0;
      function loadFacets() {
        tries++;
        gql(facetQ, { handle: cfg.collectionHandle }).then(function (d) {
          var apiFilters = (d && d.collection && d.collection.products.filters) || [];
          if (!apiFilters.length && tries < 3) { setTimeout(loadFacets, 400 * tries); return; } // retry si vide
          if (!apiFilters.length) { priceMax = 200; renderGroups(fixedGroups()); if (grid) grid.setAttribute('data-cf-facets', 'fallback'); }
          else { priceMax = priceMaxFromFacets(apiFilters); renderGroups(groupsFromApi(apiFilters)); if (grid) grid.setAttribute('data-cf-facets', 'api'); }
          afterBuild();
        }).catch(function () {
          if (tries < 3) { setTimeout(loadFacets, 400 * tries); return; } // retry si erreur
          priceMax = 200; renderGroups(fixedGroups()); if (grid) grid.setAttribute('data-cf-facets', 'fallback-err'); afterBuild();
        });
      }
      loadFacets();
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
